import {
	ICorrectionWayPointSingleVoyage,
	IWayPointCreationWithCorrectionsSingleVoyage,
	IWayPointSingleVoyage
} from "@containers/singleVoyage/types/point";
import {getLatLngFromPointGeomCoordinates} from "@helpers/geoJson/getLatLngFromPointGeomCoordinates";

export const getInitialWaypointsCreationWithCorrectionsSingleVoyage = (
	points: IWayPointSingleVoyage[]
): IWayPointCreationWithCorrectionsSingleVoyage[] => {
	if (!points.length) {
		return []
	}
	const correctionMap: Record<string, (ICorrectionWayPointSingleVoyage & { shapeOrdinal: number })[]> = {}
	
	const sorted = points?.slice()?.sort((a, b) => a?.shapeOrdinal - b?.shapeOrdinal)
	let lastPlannedOrdinal = 0
	sorted.forEach(point => {
		if (
			(point?.type === 'POINT_RADIUS' && point?.plannedOrdinal) ||
			(point?.type === 'RFID_POINT' && point?.plannedOrdinal)
		) {
			lastPlannedOrdinal = point.plannedOrdinal
		}
		if (point?.type !== 'SHAPING_POINT') {
			return
		}
		if (!(lastPlannedOrdinal?.toString() in correctionMap)) {
			correctionMap[lastPlannedOrdinal?.toString()] = []
		}
		const {lat, lng} = getLatLngFromPointGeomCoordinates(point?.geom)
		correctionMap[lastPlannedOrdinal.toString()].push({
			lat,
			lng,
			id: point?.id,
			shapeOrdinal: point?.shapeOrdinal
		})
	})
	
	return sorted?.filter((point) => point?.type === 'POINT_RADIUS' || point?.type === 'RFID_POINT')?.map((point) => {
		return {
			// shaping points are grouped under the plannedOrdinal of the stop they follow
			correctionWaypoints: correctionMap[String(point.plannedOrdinal)]
				?.slice()
				?.sort((a, b) => a?.shapeOrdinal - b?.shapeOrdinal) ?? [],
			plannedOrdinal: point.plannedOrdinal,
			type: point.type,
			geom: point.geom,
			id: point.id,
			shapeOrdinal: point.shapeOrdinal,
			radius: point.radius,
			address: point.address,
			plannedDeparture: point.plannedDeparture,
			name: point.name,
			status: point.status,
			plannedArrival: point.plannedArrival,
			waypointTemplateId:point.waypointTemplate?.id || null
			
		}
	})
}